import { jsonFetch } from '../../shared/utils/jsonFetch';
import { tryCatch } from '../../shared/utils/tryCatch';

export const getPriceOfferListPackages = async (apiUrl, siteId, priceOfferId, userId, isCharter, useUpsellUrl) => {
  const url = `${apiUrl}/api/get-price-offer-list-packages?siteId=${siteId}&priceOfferId=${priceOfferId}&userId=${userId}&isCharter=${isCharter}&useUpsellUrl=${useUpsellUrl}`;

  const [error, json] = await tryCatch(async () => {
    const response = jsonFetch(url, {
      method: 'GET',
      caller: 'price-offer',
    });
    return response;
  });

  if (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }

  return json;
};
